<template>
  <div id="section--datos">
    <section>
      <div class="card card-custom">
        <div class="card-body">
          <p class="ml-3 mt-2 mb-3 font-label" style="color: red !important">
            Verifica que los datos del conductor habitual sean correctos antes
            de emitir
          </p>
          <h3 class="mt-4 mb-3 title-custom">Datos del contratante</h3>

          <div class="d-flex flex-wrap">
            <div class="form-group col-lg-4 col-md-4">
              <label class="font-label">Tipo de Persona</label>
              <select
                name="version"
                class="form-control"
                v-model="tipoPersona"
                @change="
                  errorBirthdate = tipoPersona === 2 ? false : errorBirthdate;
                  catalogoRegimenFiscal();
                "
              >
                <option value="">-- Selecciona</option>
                <option
                  v-for="(tipo, i) in tipoPersonaArray"
                  :key="i"
                  :value="tipo.value"
                >
                  {{ tipo.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="d-flex flex-wrap">
            <div class="form-group col-lg-4 col-md-4">
              <label class="font-label">{{
                tipoPersona === 1 ? "Nombre completo" : "Razón social"
              }}</label>
              <input
                type="text"
                name="fullname"
                class="form-control"
                v-model="fullname"
                required
              />
            </div>

            <div class="form-group col-lg-4 col-md-4" v-if="tipoPersona === 1">
              <label class="font-label">Apellido paterno</label>
              <input
                type="text"
                name="paterno"
                class="form-control"
                v-model="paterno"
                required
              />
            </div>

            <div class="form-group col-lg-4 col-md-4" v-if="tipoPersona === 1">
              <label class="font-label">Apellido materno</label>
              <input
                type="text"
                name="materno"
                class="form-control"
                v-model="materno"
                required
              />
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">RFC</label>
              <div class="input-group">
                <input
                  type="text"
                  name="rfc"
                  class="form-control"
                  v-model="rfc"
                  maxlength="13"
                  @keypress="clsAlphaNoOnly"
                  required
                />
                <button
                  v-if="tipoPersona === 1"
                  class="btn btn-danger font-label"
                  type="button"
                  @click="consultaSiglasRFC()"
                >
                  Consultar
                </button>
              </div>
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label" for="">{{
                tipoPersona === 1
                  ? "Fecha de nacimiento"
                  : "Fecha de constitución"
              }}</label>
              <input
                type="date"
                name="fecha_nac"
                v-model="fecha_nac"
                class="form-control"
                @change="validateBirthdate"
                required
              />
              <small class="text-danger" v-if="errorBirthdate"
                >La edad no puede ser menor de 16 ni mayor a 90</small
              >
            </div>

            <div class="form-group col-lg-6 col-md-6">
              <label class="font-label">Dirección</label>
              <input
                type="text"
                name="address"
                class="form-control"
                v-model="address"
                required
              />
            </div>

            <div class="form-group col-lg-2 col-md-2">
              <label class="font-label">Número exterior</label>
              <input
                type="text"
                name="noExt"
                class="form-control"
                v-model="noExt"
                required
              />
            </div>

            <div class="form-group col-lg-2 col-md-2">
              <label class="font-label">Número interior</label>
              <input
                type="text"
                name="noInt"
                class="form-control"
                v-model="noInt"
              />
            </div>

            <div class="form-group col-lg-2 col-md-2">
              <label class="font-label">Código postal</label>
              <input
                type="number"
                name="cp"
                class="form-control"
                @keyup="handleCP"
                v-model="cp"
                required
              />
              <small class="text-danger" v-if="malformedCP"
                >Código postal incorrecto</small
              >
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Colonia</label>
              <select class="form-control" v-model="colonia" required>
                <option
                  v-for="(col, i) in colonias"
                  :key="i"
                  :value="col.colonia"
                >
                  {{ col.colonia }}
                </option>
              </select>
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Alcaldía o Municipio</label>
              <input
                type="text"
                name="municipio"
                class="form-control"
                v-model="municipio"
                disabled
                required
              />
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Estado</label>
              <input
                type="text"
                name="estado"
                class="form-control"
                disabled
                :value="estado"
              />
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Teléfono</label>
              <input
                type="number"
                name="phone"
                class="form-control"
                v-model="phone"
                required
                disabled
              />
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Correo electrónico</label>
              <input
                type="email"
                name="email"
                class="form-control"
                @blur="validateEmail"
                v-model="correo"
                required
                disabled
              />
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Régimen fiscal</label>
              <select
                name="version"
                class="form-control"
                v-model="regimenFiscal"
              >
                <option value="">-- Selecciona</option>
                <option
                  :value="cat.ID_FACT_REG_FISCAL"
                  v-for="(cat, i) in catRegimenFiscal"
                  :key="i"
                >
                  {{ cat.DESCT_REG_FISCAL }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="card-body">
          <h3 class="mt-4 mb-3 title-custom">Datos del vehículo</h3>
          <div class="d-flex flex-wrap">
            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Número de Serie</label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  aria-label="Recipient's username"
                  name="numeroSerie"
                  v-model="numeroSerie"
                  maxlength="17"
                  required
                />
                <button
                  class="btn btn-danger font-label"
                  type="button"
                  @click="validarSerie()"
                >
                  Validar
                </button>
              </div>
              <small class="text-danger">{{ messageNumeroSerie }}</small>
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Placas</label>
              <input
                type="text"
                name="numeroPlacas"
                class="form-control"
                v-model="numeroPlacas"
                maxlength="7"
              />
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <!-- <label class="font-label">Número de Motor</label>
              <input
                type="text"
                name="numeroMotor"
                class="form-control"
                v-model="numeroMotor"
                maxlength="20"
              /> -->
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <!-- <label class="font-label">Numero de Control Vehicular</label>
              <input
                type="text"
                name="numeroControlVehicular"
                class="form-control"
                v-model="numeroControlVehicular"
              /> -->
            </div>

            <div class="form-group col-lg-6 col-md-6">
              <label class="font-label">Datos del conductor habitual</label>
              <input
                type="text"
                name="conductorHabitual"
                class="form-control"
                v-model="conductorHabitual"
                readonly
                required
              />
            </div>

            <div class="form-group col-lg-6 col-md-6">
              <label class="label-custom">Beneficiario preferente</label>
              <input type="text" class="form-control" v-model="beneficiario" />
            </div>

            <div class="form-group col-lg-3 col-md-3" v-if="valorFactura > 0">
              <label class="font-label">Valor factura</label>
              <input
                type="text"
                name="valorFactura"
                class="form-control"
                v-model="valorFactura"
                readonly
              />
            </div>

            <div class="col-md-12">
              <p class="font-label">
                Para verificar los datos proporcionados, después de contratar el
                <span class="fw-bold">Seguro Valor Latino</span>, enviaremos una
                liga para que el cliente pueda realizar la inspección de su
                auto. Recuerda que el dato de kilometraje así como realizar la
                inspección correctamente, son imprescindibles para respetar los
                términos y condiciones contratados en la póliza en caso de
                siniestro.
              </p>
            </div>
          </div>
        </div>
        <div class="card-body" v-if="cobProteccionFamExists">
          <h3 class="mt-4 mb-3 title-custom">Protección familiar</h3>
          <div class="d-flex flex-wrap">
            <div class="col-md-12">
              <p>
                <span class="fw-bold">IMPORTANTE:</span> En caso de que el
                domicilio a cubrir sea diferente, actualiza los datos.
              </p>
            </div>

            <div class="form-group col-lg-5 col-md-5">
              <label class="font-label">Dirección</label>
              <input
                type="text"
                name="direccionFam"
                class="form-control"
                v-model="direccionFam"
                required
              />
            </div>

            <div class="form-group col-lg-2 col-md-2">
              <label class="font-label">Número exterior</label>
              <input
                type="text"
                name="numExteriorFam"
                class="form-control"
                v-model="numExteriorFam"
                required
              />
            </div>

            <div class="form-group col-lg-2 col-md-2">
              <label class="font-label">Número interior</label>
              <input
                type="text"
                name="numInteriorFam"
                class="form-control"
                v-model="numInteriorFam"
              />
            </div>

            <div class="form-group col-lg-3 col-md-3">
              <label class="font-label">Código postal Fam</label>
              <input
                type="number"
                name="cpFam"
                class="form-control"
                @keyup="handleCPFam"
                v-model="cpFam"
                required
              />
              <small class="text-danger" v-if="malformedCPFam"
                >Código postal incorrecto</small
              >
            </div>

            <div class="form-group col-lg-4 col-md-4">
              <label class="font-label">Colonia</label>
              <select class="form-control" v-model="coloniaFam" required>
                <option
                  v-for="(col, i) in coloniasFam"
                  :key="i"
                  :value="col.colonia"
                >
                  {{ col.colonia }}
                </option>
              </select>
            </div>

            <div class="form-group col-lg-4 col-md-4">
              <label class="font-label">Alcaldía o Municipio</label>
              <input
                type="text"
                name="municipioFam"
                class="form-control"
                v-model="municipioFam"
                required
                disabled
              />
            </div>

            <div class="form-group col-lg-4 col-md-4">
              <label>Estado</label>
              <input
                type="text"
                name="estadoFam"
                class="form-control"
                v-model="estadoFam"
                required
                disabled
              />
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="d-flex flex-wrap">
            <div class="col-12 d-flex justify-content-between">
              <button
                class="btn btn-primary btn-rounded mr-2"
                @click="handleNavigation('no-payment')"
                :disabled="loading"
              >
                {{ loading ? "Cargando..." : "Emitir y pagar después" }}
              </button>
              <button
              v-if="this.datosCotizacion.ESTATUSINSPECCION !== '0'"
                class="btn btn-primary btn-rounded"
                @click="handleNavigation('payment')"
                :disabled="loading"
              >
                {{ loading ? "Cargando..." : "Emitir y pagar en línea" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { format, validate, form } from "../../../../assets/helpers";
import {
  axiosBaseUrl,
  enableLoading,
} from "../../../../store/actions/ModuloActions";

export default {
  props: {
    data: Object,
    payload: Object,
    poliza: Object,
    basicas: Array,
    total: Number,
    primas: Array,
    planSelectedPrimas: Number,
    idCotizacion: String,
    paquete: String,
    urlPayment: String,
    idPoliza: String,
    enviarPDF: Function,
    referencia: String,
    datosCotizacion: Object,
    email: String,
    showPolizaExitosa: Function,
    showPolizaExitosaSinDocs: Function
  },
  data() {
    return {
      address: "",
      catRegimenFiscal: [],
      cobProteccionFamExists:
        this.datosCotizacion.INCISOS[0].COBERTURAS.findIndex(
          (bas) => bas.NOMENCLATURA === "RCF"
        ) !== -1,
      colonia: "",
      coloniaFam: "",
      conductorHabitual: this.datosCotizacion.CLIENTE.NOMBRE || "",
      correo: this.datosCotizacion.CLIENTE.CORREO || "",
      cp: this.datosCotizacion.CLIENTE.CODIGOPOSTAL || "",
      cpFam: "",
      delegacion: "",
      direccionFam: "",
      errorBirthdate: false,
      estado: this.datosCotizacion.CLIENTE.ESTADO || "",
      estadoFam: "",
      fecha_nac:
        this.formatInputDate(
          new Date(
            format.date(
              this.datosCotizacion.CLIENTE.FECHANACIMIENTO,
              "aaaa/mm/dd"
            )
          ),
          0
        ) || "",
      fullname: "",
      malformedCP: false,
      malformedCPFam: false,
      materno: "",
      codigoNumeroSerie: "",
      messageNumeroSerie: "",
      municipio: "",
      municipioFam: "",
      noExt: "",
      noInt: "",
      numeroControlVehicular: "",
      numeroMotor: "",
      numeroPlacas: "",
      numeroSerie: "",
      numExteriorFam: "",
      numInteriorFam: "",
      paterno: "",
      pdfCondiciones: "",
      pdfPoliza: "",
      pdfSolicitud: "",
      pdfChubb: "",
      pdfDerechos: "",
      pdfCertificadoChubb: "",
      phone: this.datosCotizacion.CLIENTE.TELEFONO || "",
      regimenFiscal: "",
      rfc: "",
      tipoPersona: 1,
      tipoPersonaArray: [
        {
          name: "Persona Fisica",
          value: 1,
        },
        {
          name: "Persona Moral",
          value: 2,
        },
      ],
      universe: "",
      universe2: "",
      valorFactura: this.datosCotizacion.INCISOS[0].VALORNUEVO,
      beneficiario: "",
      loading: false,
      colonias: [],
      coloniasFam: [],
    };
  },
  methods: {
    getSectionName(index) {
      const nombreCompleto = this.datosCotizacion.CLIENTE.NOMBRE.split(" ");
      return nombreCompleto[index];
    },
    formatInputDate(date, add) {
      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        date.getFullYear(),
        this.padTo2Digits(date.getMonth() + 1),
        this.padTo2Digits(date.getDate()),
      ].join("-");
    },
    formatDateBirthday(date, add) {
      if (add > 0) {
        date.setDate(date.getDate() + add);
      }

      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join("/");
    },
    padTo2Digits(num) {
      return num.toString().padStart(2, "0");
    },
    validateBirthdate(e, element = false) {
      if (this.tipoPersona === 2) {
        this.errorBirthdate = false;
        return true;
      }

      const dateElement = element ? element : e.target.value;
      const splited = dateElement.split("-");

      if (splited.length == 3) {
        if (splited[0].length > 4) {
          e.target.value = `${splited[0].slice(0, -1)}-${splited[1]}-${
            splited[2]
          }`;
        }
      }

      if (!dateElement) {
        return false;
      }

      const today = new Date();
      const inputDate = new Date(format.date(dateElement, "aaaa-mm-dd"));
      const maxDate = new Date(
        today.getFullYear() - 16,
        today.getMonth(),
        today.getDate()
      );

      const minDate = new Date(
        today.getFullYear() - 90,
        today.getMonth(),
        today.getDate() - 1
      );

      if (inputDate < minDate || inputDate > maxDate) {
        this.errorBirthdate = true;
        return false;
      }
      this.errorBirthdate = false;
      return true;
    },
    handleCP(e) {
      const cp = e.target.value;
      this.estado = "";
      this.municipio = "";
      this.delegacion = "";

      if (isNaN(cp)) {
        this.$swal.fire({
          title: "Sólo números son permitidos",
        });
        e.target.value = cp.slice(0, -1);
        return;
      }

      this.malformedCP = false;

      if (cp.length == 5) {
        this.cp = cp;
        this.getAddress("individual", this.cp, this.estado);
      } else if (cp.length > 5) {
        this.malformedCP = true;
      }
    },
    handleCPFam(e) {
      const cp = e.target.value;

      this.estadoFam = "";
      this.municipioFam = "";

      if (isNaN(cp)) {
        this.$swal.fire({
          title: "Sólo números son permitidos",
        });
        e.target.value = cp.slice(0, -1);
        return;
      }

      this.malformedCPFam = false;

      if (cp.length == 5) {
        this.cpFam = cp;
        this.getAddress("fam", this.cpFam, this.estadoFam);
      } else if (cp.length > 5) {
        this.malformedCPFam = true;
      }
    },
    validateEmail(e) {
      const target = e.target.value;

      if (!validate.email(target)) {
        this.$swal.fire({
          title: "No es un email válido",
        });
        e.target.value = "";
        return;
      }
    },
    handleNavigation(type) {
      const fakeForm = document.querySelector("#section--datos");

      if (!form.validate(fakeForm)) {
        return this.$swal("Error", "Todos los campos son obligatorios");
      }
      if (this.messageNumeroSerie === "") {
        return this.$swal(
          "Error",
          "Se necesita llenar y validar el numero de serie"
        );
      }

      if (this.codigoNumeroSerie === "0") {
        return this.$swal("Error", "El numero de serie es invalido");
      }

      const payload = form.build(fakeForm);
      payload.fullname = this.fullname;
      payload.rfc = this.rfc;
      payload.fecha_nac = this.fecha_nac;
      payload.address = this.address;
      payload.noExt = this.noExt;
      payload.noInt = this.noInt;
      payload.cp = this.cp;
      payload.colonia = this.colonia;
      payload.delegacion = this.delegacion;
      payload.municipio = this.municipio;
      payload.estado = this.estado;
      payload.municipio = this.municipio;
      payload.delegacion = this.delegacion;
      payload.correo = this.correo;
      payload.regimenFiscal = this.regimenFiscal;
      payload.phone = this.phone;
      payload.numeroSerie = this.numeroSerie;
      payload.numeroPlacas = this.numeroPlacas;
      payload.numeroMotor = this.numeroMotor;
      payload.numeroControlVehicular = this.numeroControlVehicular;
      payload.conductorHabitual = this.conductorHabitual;
      payload.beneficiarioPreferente = this.beneficiarioPreferente;
      payload.conductorRC = this.conductorRC;

      this.guardarClienteUnico(payload, type);
    },
    async handleNavigationBack(to) {
      if (to == 3) {
        const shouldGoBack = await this.$swal({
          title: "¿Desea modificar los datos?",
          text: "",
          showDenyButton: false,
          showCancelButton: true,
          confirmButtonText: "Regresar",
          denyButtonText: "Permanecer aquí",
        });

        if (!shouldGoBack.isConfirmed) {
          return;
        }
        return this.$emit("onChangeStep", to);
      }
    },
    getCoberturas() {
      const cobsTemp = [];

      this.datosCotizacion.INCISOS[0].COBERTURAS.map((cob) => {
        cobsTemp.push({
          CLAVECOBERTURA: cob.NOMENCLATURA,
          DEDUCIBLE: cob.DEDUCIBLE,
          PRIMACOBERTURA: cob.PRIMA,
          SUBRAMO: "",
          SUMAASEGURADA: cob.SUMA,
        });
      });

      return cobsTemp;
    },
    // Api's
    async getAddress(type, cp, estado) {
      if (estado) {
        return;
      }

      if (type === "fam") {
        this.coloniasFam = [];
      } else {
        this.colonias = [];
      }

      const payload = {
        metodo: "GET_CP_CA",
        data: {
          cp: cp,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const address = this.$store.getters.getRespuestaREST[0];

        if (type !== "fam") {
          this.estado = address.NombreEstado;
          this.municipio = address.NombreMunicpio;
          this.delegacion = address.NombreCiudad;
          this.universe = address.MunUniverse;
          this.universe2 = address.Universe;
        } else {
          this.estadoFam = address.NombreEstado;
          this.municipioFam = address.NombreMunicpio;
        }

        this.$store.getters.getRespuestaREST.map((dir) => {
          if (type === "fam") {
            this.coloniasFam.push({
              clave: dir.ClaveColonia,
              colonia: dir.NombreColonia,
            });
          } else {
            this.colonias.push({
              clave: dir.ClaveColonia,
              colonia: dir.NombreColonia,
            });
          }
        });
      }
    },
    async guardarClienteUnico(payloadForm, type) {
      this.loading = true;

      const payload = {
        metodo: "GUARDARCLIENTEUNICO",
        data: {
          TipoPersona: this.tipoPersona,
          Nombre: this.fullname,
          APaterno: this.tipoPersona === 2 ? "" : this.paterno,
          AMaterno: this.tipoPersona === 2 ? "" : this.materno,
          FechaNacimiento: this.formatDateBirthday(new Date(this.fecha_nac), 1),
          RFC: this.rfc,
          Cp: this.cp,
          Colonia: this.colonia,
          Calle: this.address,
          NumExt: this.noExt,
          NumInt: this.noInt,
          DomicilioPrincipal: this.address,
          IdRegistroFiscal: this.regimenFiscal,
          Correo: this.correo,
          Telefono: this.phone,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.guardarPoliza(response.IdCLiente, payloadForm, type);
      } else {
        this.loading = false;
        return this.$swal("Error", "Ha ocurrido un error");
      }
    },
    async guardarPoliza(id, payloadForm, type) {
      const payload = {
        metodo: "GUARDARPOLIZA",
        data: {
          AGENTE: this.datosCotizacion.AGENTE,
          CLIENTE: {
            IDCLIENTE: id,
            CORREO: this.correo,
            CP: this.cp,
            FECHANACIMIENTO: this.formatDateBirthday(
              new Date(this.fecha_nac),
              1
            ),
            NOMBRE: this.datosCotizacion.CLIENTE.NOMBRE,
            SEXO: this.datosCotizacion.CLIENTE.SEXO,
            TELEFONO: this.phone,
          },
          COTIZACION: this.idCotizacion,
          ENTIDAD: this.universe || this.universe2,
          FECHAALTA: this.formatDateBirthday(new Date(), 0),
          FECHAINSPECION: "",
          FP: this.datosCotizacion.FP,
          GASTOS: this.datosCotizacion.GASTOS,
          INCISOS: [
            {
              CLAVE: this.datosCotizacion.INCISOS[0].CLAVE,
              COBERTURAS: this.getCoberturas(),
              CONDUCTOR: this.conductorHabitual,
              CONTROLVEHICULAR: this.numeroControlVehicular,
              KILOMETRAJE: this.datosCotizacion.INCISOS[0].KILOMETRAJE,
              MODELO: this.datosCotizacion.INCISOS[0].MODELO,
              MOTOR: this.numeroMotor,
              PLACAS: this.numeroPlacas,
              SAVEHICULO: 0,
              SERIE: this.numeroSerie,
              TIPOCARGA: "",
              TIPOPAQUETE: +this.datosCotizacion.INCISOS[0].TIPOPAQUETE,
              VALORNUEVO: this.datosCotizacion.INCISOS[0].VALORNUEVO,
              FECHAFACTURA: this.datosCotizacion.INCISOS[0].FECHAFACTURA,
              FAMILIAR: {
                ALCALDIA: this.municipioFam,
                COLONIA: this.coloniaFam,
                DIRECCION: this.direccionFam,
                ESTADO: this.estadoFam,
                EXTERIOR: this.numExteriorFam,
                INTERIOR: this.numInteriorFam,
                POSTAL: this.cpFam,
              },
              BENEFICIARIO: this.beneficiario,
            },
          ],
          IVA: this.datosCotizacion.IVA,
          MONEDA: 0,
          POLIZA: "",
          PRIMANETA: this.datosCotizacion.PRIMANETA,
          RECARGOS: this.datosCotizacion.RECARGOS,
          SUBTOTAL: this.datosCotizacion.SUBTOTAL,
          SUMAASEGURADA: this.datosCotizacion.SUMAASEGURADA,
          TOTAL: this.datosCotizacion.TOTAL,
          USUARIO: localStorage.getItem("userId"),
          VIGENCIAFIN: this.datosCotizacion.FIN,
          VIGENCIAINI: this.datosCotizacion.INICIO,
        },
      };

      this.$store.dispatch("enableLoading").then((_) => {});

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        payloadForm.idCliente = id;
        payloadForm.idPoliza = response.POLIZA;
        this.$emit("update:idPoliza", response.POLIZA);
        this.$emit("update:referencia", `${response.REFERENCIA}`);
        this.$emit("update:email", this.correo);

        this.inspeccion(id, response.POLIZA);

        if (this.datosCotizacion.ESTATUSINSPECCION === "1") {
          this.sendPolizaEmail(response.POLIZA, type, response.REFERENCIA, id);
        } else {
          this.showPolizaExitosaSinDocs();
          this.loading = false;
          this.$store.dispatch("disabledLoading").then((_) => {});
        }
      } else {
        this.loading = false;
        this.$store.dispatch("disabledLoading").then((_) => {});
        return this.$swal("Error", "Ha ocurrido un error");
      }
    },
    getValorNuevo() {
      const { monto_factura } = this.payload;
      const valorFactura = monto_factura
        ? +monto_factura.replaceAll(",", "")
        : 0;

      const cobsCheck = this.basicas.filter((cob) => cob.check);

      const searchValorFactura = cobsCheck.find(
        (cob) =>
          cob.SUMAS.find(
            (sum) =>
              sum.VALOR === cob.checkSumas &&
              sum.DESCRIPCION === "VALOR FACTURA"
          ) !== undefined
      );
      const searchValorConvenido = cobsCheck.find(
        (cob) =>
          cob.SUMAS.find(
            (sum) =>
              sum.VALOR === cob.checkSumas &&
              sum.DESCRIPCION === "VALOR CONVENIDO"
          ) !== undefined
      );
      const searchValorComercial = cobsCheck.find(
        (cob) =>
          cob.SUMAS.find(
            (sum) =>
              sum.VALOR === cob.checkSumas &&
              sum.DESCRIPCION === "VALOR COMERCIAL"
          ) !== undefined
      );

      if (searchValorFactura !== undefined) {
        return valorFactura;
      } else if (searchValorConvenido !== undefined) {
        const value = searchValorConvenido.SUMAS.find(
          (sum) => sum.VALOR === searchValorConvenido.checkSumas
        );
        return value.VALOR;
      } else if (searchValorComercial !== undefined) {
        return 0;
      } else {
        return valorFactura;
      }
    },
    sumasCoberturas() {
      let total = 0;
      this.basicas.map(
        (cob) => (total = cob.check ? total + cob.checkSumas : total + 0)
      );
      return total;
    },
    async billingNetpay(referencia, idCliente, poliza) {
      this.$emit(
        "update:urlPayment",
        localStorage.getItem("urlPago") +
          `?monto=${this.datosCotizacion.RECIBO1}&referencia=${referencia}&TipoMoneda=MXN&idAplicacion=6&Folio=${poliza}&concepto=Pago Valor Latino, de la póliza: ${poliza}`
      );
      const modal = document.getElementById("polizaModal");
      modal.click();
    },
    inspeccion(idCliente, poliza) {
      this.$store.dispatch("enableLoading").then((_) => {});

      const payload = {
        metodo: "INSPECCIONV3",
        data: {
          ApellidoMaterno: this.materno,
          ApellidoPaterno: this.paterno,
          Email: this.correo,
          Geolocalizacion:"",
          Kilometraje: this.datosCotizacion.INCISOS[0].KILOMETRAJE,
          Marca: this.datosCotizacion.INCISOS[0].MARCA,
          Modelo: this.datosCotizacion.INCISOS[0].MODELO,
          Nombre: this.fullname,
          NumeroInciso: "001",
          NumeroPoliza: poliza,
          idRenovacion: 0,
          idOpcional: 0,
          Placa: this.numeroPlacas,
          Submarca: this.datosCotizacion.INCISOS[0].SUBMARCA,
          Telefono: this.phone,
          VIN: this.numeroSerie,
          Agente: localStorage.getItem("userId"),
          Promotor: "5444",
          idClienteUnico: idCliente,
          idCatProducto: 3,
          idRamo: "34",
          movimiento: "Inspeccion",
          NumeroRenovacion: "",
          tipoUnidad: "AU",
          tramite: "Anexo",
          vehiculo: this.datosCotizacion.INCISOS[0].DESCRIPVEH,

          /*NumeroPoliza: poliza,
          Inciso: "1",
          VIN: this.numeroSerie,
          IdClienteUnico: idCliente,
          NombreAs: this.fullname,
          ApePat: this.paterno,
          ApeMat: this.materno,
          Placa: this.numeroPlacas,
          NumCelularAs: this.phone,
          NumAlternoAs: "",
          EmailAs: this.correo,
          tipoUnidad: "AU",
          Marca: this.datosCotizacion.INCISOS[0].MARCA,
          Submarca: "Submarca",
          Modelo: this.datosCotizacion.INCISOS[0].DESCRIPVEH,
          Anio: this.datosCotizacion.INCISOS[0].MODELO,
          Agente: localStorage.getItem("userId"),
          Promotor: "5444",
          MovimientoVil: "Inspeccion",
          TipoTramiteVil: "Anexo",
          IdOperacion: 2,
          IdCatProducto: 3,*/
        },
      };

      this.$store
        .dispatch("metodoPost", payload)
        .then(() => {
          const response = this.$store.getters.getRespuestaREST;
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.$store.dispatch("disabledLoading").then((_) => {});
        });
    },
    async validarSerie() {
      console.log('COTIZACIÓN: ' + this.datosCotizacion.INICIO)
      const payload = {
        metodo: "VALIDARNUMEROSERIE",
        data: {
          NumSerie: this.numeroSerie,
          Ramo: '34',
          Usuario: localStorage.getItem("userId"),
          Renovacion: '0',
          VigenciaInicial: this.datosCotizacion.INICIO,
          sClaveUsuario: localStorage.getItem("userId")
        },
      };

      if (this.numeroSerie !== "") {
        const res = await this.$store.dispatch("metodoPost", payload);
        if (res) {
          const response = this.$store.getters.getRespuestaREST;
          this.codigoNumeroSerie = response.sCodigoRespuesta;
          this.messageNumeroSerie = response.sMensajeRespuesta;
        }
      } else {
        this.$swal("Error", "Es necesario ingresar un numero de serie");
      }
    },
    async catalogoRegimenFiscal() {
      this.catRegimenFiscal = [];

      const payload = {
        metodo: "CATALOGOREGIMENFISCAL",
        data: {
          TipoPersona: this.tipoPersona,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.catRegimenFiscal.push(...response);
      }
    },
    clsAlphaNoOnly(e) {
      var regex = new RegExp("^[a-zA-Z0-9 ]+$");
      var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
      if (regex.test(str)) {
        return true;
      }

      e.preventDefault();
      return false;
    },
    async sendPolizaEmail(poliza, type, referencia, id) {
      const attachments = [
        {
          RECIBO: "",
          NAME: "poliza.pdf",
          TIPODOCUMENTO: "11",
          TIPOCOTIZADOR: "2",
        },
        {
          RECIBO: "",
          NAME: "solicitud.pdf",
          TIPODOCUMENTO: "15",
          TIPOCOTIZADOR: "2",
        },
        {
          RECIBO: "",
          NAME: "condiciones.pdf",
          TIPODOCUMENTO: "16",
          TIPOCOTIZADOR: "2",
        },
        {
          RECIBO: "",
          NAME: "derechos.pdf",
          TIPODOCUMENTO: "20",
          TIPOCOTIZADOR: "2",
        },
        {
            NAME: "recibo.pdf",
            RECIBO: "",
            TIPOCOTIZADOR: "2",
            TIPODOCUMENTO: "13"
        }
      ];

      const existsRCUsa = this.datosCotizacion.INCISOS[0].COBERTURAS.find(
        (cob) => cob.NOMENCLATURA === "RCU"
      );

      if (existsRCUsa !== undefined) {
        attachments.push({
          RECIBO: "",
          NAME: "CHUBB.pdf",
          TIPODOCUMENTO: "19",
          TIPOCOTIZADOR: "2",
        });

        attachments.push({
          RECIBO: "",
          NAME: "Certificado_CHUBB.pdf",
          TIPODOCUMENTO: "17",
          TIPOCOTIZADOR: "2",
        });
      }

      this.$store.dispatch("enableLoading").then((_) => {});

      const payload = {
        metodo: "ENVIODOCUMENTOSCORREO",
        data: {
          COTIZACION: this.idCotizacion,
          POLIZA: poliza,
          ENDOSO: "",
          IDTEMPLATE: "17",
          IDMESSAGE: "",
          SENDER: "infolatino@latinoseguros.com.mx",
          SUBJECT: `Latino Seguros Póliza ${poliza.toString()}`,
          TARGETS: this.correo,
          DINAMICCONTENT: "Póliza de tu seguro de auto.",
          DOCUMENTOS: attachments,
        },
      };

      await this.$store.dispatch("metodoPost", payload).then(async() => {
        const _ = this.$store.getters.getRespuestaREST;
        await this.sendDocsWhatsApp(poliza, referencia, type)
        // window.location.href = `${location.origin}/#/cotizador/auto/cotizaciones-poliza`;
        // location.reload();
        this.showPolizaExitosa();
        this.loading = false;
        this.$store.dispatch("disabledLoading").then((_) => {});
      });
    },
    async consultaSiglasRFC() {
      if (
        (this.tipoPersona === 1 &&
          this.fullname !== "" &&
          this.paterno !== "" &&
          this.materno !== "") ||
        (this.tipoPersona === 2 && this.fullname !== "")
      ) {
        const payload = {
          metodo: "CONSULTASIGLASRFC",
          data: {
            Nombre: this.fullname,
            ApellidoPaterno: this.tipoPersona === 2 ? "" : this.paterno,
            ApellidoMaterno: this.tipoPersona === 2 ? "" : this.materno,
            Fecha: this.formatDateBirthday(new Date(this.fecha_nac), 1),
            Tipo: this.tipoPersona.toString(),
          },
        };

        await this.$store
          .dispatch("metodoPost", payload)
          .then(() => {
            const response = this.$store.getters.getRespuestaREST;
            this.rfc = response;
          })
          .catch((error) => {
            console.log(["Error", error]);
          });
      } else {
        this.$swal.fire({
          title: "Es necesario llenar los campos de nombre y apellidos",
        });
      }
    },
    async sendDocsWhatsApp(poliza, referencia, type) {
      const payload = {
        metodo: "SENDWHATSAPP",
        data: {
          documento: poliza,
          ramo: "34",
          telefono: this.phone,
          parametros: [
            {
              "texto": this.datosCotizacion.CLIENTE.NOMBRE
              },
              {
                "texto": poliza
                }        
                ],
          bImagen: "0",
          urlImagen: "",
          bDocumento: "1",
          urlDocumento: "",
          tipoDocumento: "2",
          template: type == 'no-payment' ? "emitir_y_pagar_despues_iniciales" : "emitir_y_pagar_ahora",
          bBoton: type == 'no-payment' ? "1" : "0",
          urlBoton: type == 'no-payment' ? `bancos.aspx?monto=${this.datosCotizacion.TOTAL}&referencia=${referencia}&TipoMoneda=MXN&idAplicacion=6&Folio=${poliza}&concepto=Pago+Valor+Latino+de+la+Poliza+${poliza}` : ""
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        console.log(response);
      }
    },

  },
  async mounted() {
    await this.getAddress("individual", this.cp, "");
    await this.catalogoRegimenFiscal();

    this.fullname = this.getSectionName(0);
    this.paterno = this.getSectionName(1);
    this.materno = this.getSectionName(2);
  },
};
</script>
